import React from 'react'
import SalaryActions from './salaryActions'
import CustomTable from '../../ui/DataTable'
import Pagination from '../../ui/Pagination'
import useFetch from '../../../hooks/useFetch'
import { useSelector } from 'react-redux'
import { selectCid } from '../../../features/companyid'
import { selectCustomPagination } from "../../../features/paginationStore";

const getColumns = (companyData) => [
  {
    key: "sno",
    header: "S.No",
    body: (row) => {
      return (
        <div className='w-fit ml-2'>{row.sno}</div>
      )
    },
    width: "fit-content"
  },
  {
    key: "name",
    header: "Name",
    body: (row) => {
      return (
        <div className='w-fit ml-2 max-w-[300px]'>{row.name || "Random Name" + row.sno}</div>
      )
    },
    width: "300px",
    notCentered: true,
  },
  {
    key: "mapped_offer",
    header: "Mapped Offer",
    body: (row) => {
      return (

        row.mapped_offer && row?.mapped_offer_details?.length > 0 ?
          <div className='w-fit max-w-[300px] mx-auto'>{row.mapped_offer_details.map((row) => <>{row.name}<br /></>)}</div> :
          <div className='text-red-500 w-fit mx-auto'>Not Linked</div>
      )
    },
  },
  {
    key: "action",
    header: "Actions",
    body: (row) => {
      return (
        <SalaryActions id={row.uuid} companyData={companyData} />
      )
    }
  }
];

const SalaryTemplate = ({ companyData }) => {

  const cid = useSelector(selectCid);

  const { data = [], isLoading } = useFetch("/v2/template/getall/" + cid + "?type=salary");

  const { page, page_size } = useSelector((state) =>
    selectCustomPagination(state, "salaryTemplate")
  );

  const finalData = [...(data.templates || [])]
    .sort((a, b) => a.name.localeCompare(b.name))
    .map((row, index) => ({
      ...row,
      sno: index + 1,
    }))
    .slice((page - 1) * page_size, page * page_size);

  const totalPage = Math.ceil((data?.count || 0) / page_size);

  return (
    <div className='rounded-xl bg-white border border-gray-200 overflow-hidden'>
      <CustomTable columns={getColumns(companyData)}
        laoding={isLoading}
        tableData={finalData || []}
        className='!px-0 rounded-xl'
        tableClass='!my-0 !border-t-0'
        noBorder
      />

      <div className='w-full pt-[1px] mb-4 bg-gray-200' />

      <Pagination totalPages={totalPage} page={page} pageKey="salaryTemplate" />
    </div>
  )
}

export default SalaryTemplate